<template>
  <a-modal :visible="open" title="问卷调查" @ok="handleSubmit" @cancel="emit('close')" style="top: 30%" :zIndex="1010">
    <p class="title">欢迎来到YinoLink周5出海，请选择你想要详细了解的海外平台，以便于我们后续为您继续推荐：</p>
    <a-checkbox-group v-model:value="checkedList" :options="plainOptions" />
  </a-modal>
</template>

<script setup>
import { ref } from 'vue'
import { submitForm } from '@/request/api/question.js'
import { message } from 'ant-design-vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['close'])

const checkedList = ref([])
const plainOptions = ref(['Facebook', 'TikTok', 'Bing', 'Google', '其他'])

const handleSubmit = () => {
  submitForm({ type: 1, media_type: checkedList.value.join(',') }).then((res) => {
    if (res.code === 200) {
      message.success(res.msg)
      emit('close')
    }
  })
}
</script>
<style scoped>
.title {
  color: #3a84ff;
  font-weight: 600;
}
</style>
